var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuIconSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "2.5 2.5 19 19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M16.7,14.9l0.3-0.5c0.7-1.2,1.1-2.6,1.1-4c-0.1-4.4-3.6-7.9-8-8c-4.3,0-7.7,3.5-7.7,7.8c0.1,4.4,3.6,7.9,8,8 l0,0c1.4,0,2.7-0.4,3.9-1.1l0.5-0.3l4.7,4.7c0.2,0.2,0.6,0.2,0.8,0l1.3-1.3c0.1-0.1,0.2-0.2-0.2-0.6L16.7,14.9z M10.3,16.2 c-3.3-0.1-6-2.8-6.1-6.1l0,0c0-3.2,2.6-5.9,5.9-5.9c3.3,0.1,6,2.8,6.1,6.1C16.2,13.6,13.6,16.2,10.3,16.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconSearch);
export default __webpack_public_path__ + "static/media/menu-icon-search.04e8de04b2e19a0fe421097837d9c6d0.svg";
export { ForwardRef as ReactComponent };